function toggleCalendarView(event) {
    if(dragging) return;

    var target = event.target.closest(".change-calendar-view");
    if(target) {
        event.preventDefault();
        event.stopPropagation();

        // Toggle active view
        document.querySelector(".view.active").classList.remove("active");
        document.querySelector(".view." + target.getAttribute("data-value")).classList.add("active");
    }
}
document.addEventListener("change", toggleCalendarView);

function changeMonth(event) {
    var target = event.target.closest("select[name='month']");
    if(target) {
        event.preventDefault();
        event.stopPropagation();

        calendarFilterSearch.submit();
    }
}
document.addEventListener("change", changeMonth);

function filterEventByCategory(event) {
    var target = event.target.closest("select[name='category']");
    if(target) {
        event.preventDefault();
        event.stopPropagation();

        calendarFilterSearch.submit();
    }
}
document.addEventListener("change", filterEventByCategory);